module.exports = __webpack_public_path__ + "173cad443da2e77672a1cf3bd4d652d0.MP3";